import React from 'react';
import { Pane, PaneBody, PaneHeader } from '../../atoms/applications/page';
import { PlanSelector } from '../../atoms/applications/plans';
import { CampaignList } from '../../atoms/applications/CampaignList';
import { SelectedPlanSummary } from '../../atoms/applications/SelectedPlanSummary';
import { PlanNotice, PlanOptionSelector } from '../../atoms/applications/planOptions';
import { ButtonWrapper, SubmitButton } from '../../atoms/forms/vertical/base';
import { inject, observer } from 'mobx-react';
import { MembershipPlanUpdateState } from '../../../containers/membership_plans/states/MembershipPlanUpdateState';
import { CurrentPlanSummary } from './update/CurrentPlanSummary';
import './planSelectionPane.module.scss';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { LessonDeactivationWarning } from './update/LessonDeactivationWarning';

type Props = {
  pageState: MembershipPlanUpdateState;
};

export const PlanSelectionPane = inject('pageState')(
  observer(
    class PlanSelectionPane extends React.Component<Props> {
      render() {
        const {
          pageState: {
            plans,
            currentSubscriptionSummary,
            selectedPlanId,
            selectPlan,
            selectedPlan,
            currentItemId,
            selectedItemId,
            selectedItem,
            selectItem,
            validatePlanAndNext,
            confirmedLessonDeactivation,
            setConfirmedLessonDeactivation,
          },
        } = this.props;
        const showDeactivationWarning = selectedPlan && selectedItem && selectedPlan.lesson_deactivation;
        return (
          <Pane id="plan-selection-pane">
            <div styleName="block">
              <PaneHeader>現在のプラン</PaneHeader>
              <PaneBody>
                <CurrentPlanSummary summary={currentSubscriptionSummary} />
              </PaneBody>
            </div>
            <div styleName="block">
              {GlobalStatesV3.viewport.isNonSp && <PaneHeader>プランの選択</PaneHeader>}
              <PaneBody>
                <PlanSelector plans={plans.getOrElse([])} selectedPlanId={selectedPlanId} onPlanChange={selectPlan} />
                {selectedPlan && selectedPlan.discount_campaigns.length > 0 && (
                  <CampaignList campaigns={selectedPlan.discount_campaigns} />
                )}
                {selectedPlan && <SelectedPlanSummary plan={selectedPlan} />}
                {selectedPlan && (
                  <PlanOptionSelector
                    currentItemId={currentItemId}
                    selectedItemId={selectedItemId}
                    items={selectedPlan.items}
                    onItemSelect={selectItem}
                  />
                )}
                <PlanNotice>
                  ※ 月額料金のお支払いは、まとめてご一括のみとなります
                  <br />※ お申込日を起算日とし、自動更新されます。12ヶ月後(12ヶ月プラン) / 6ヶ月後(6ヶ月プラン) /
                  1ヶ月後(月額プラン) 各プラン自動更新されます
                </PlanNotice>
                {showDeactivationWarning && (
                  <LessonDeactivationWarning
                    confirmed={confirmedLessonDeactivation}
                    onConfirmationChange={setConfirmedLessonDeactivation}
                  />
                )}
                <ButtonWrapper>
                  <SubmitButton id="submit-button" disabled={selectedItem == null} onClick={validatePlanAndNext}>
                    お支払い情報の入力へ
                  </SubmitButton>
                </ButtonWrapper>
              </PaneBody>
            </div>
          </Pane>
        );
      }
    }
  )
);
